// extracted by mini-css-extract-plugin
module.exports = {"declaration":"_1kfnRvKax2oXfhIzQqTN1g==","footer":"S5sa90CmmxGAxfddRGIVgA=="};